/*
 * @Description: 新增、编辑科室对话框中各面板共用的数据
 * @Author: gaohc
 * @Date: 2022-05-07 18:28:58
 */
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const state = {
  mode: "",
  inpatientWard: {}
};

const mutations = {
  changeMode(stateN, mode) {
    stateN.mode = mode;
  },

  changeInpatientWard(stateN, inpatientWard) {
    stateN.inpatientWard = inpatientWard;
  }
};

export default new Vuex.Store({
  state: state,
  mutations: mutations
});



// WEBPACK FOOTER //
// ./src/components/hspmng/components/departmentList/DepStore.js